import { CommonModule, isPlatformBrowser, DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, Inject, Input, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Item } from '../../item-detail/item-detail.service';
import { MatIconModule } from '@angular/material/icon';
import { Dialog } from '@angular/cdk/dialog';
import { CartQtyControlComponent } from '../../cart-qty-control/cart-qty-control.component';
import html2canvas from 'html2canvas-pro';
import { MatRippleModule } from '@angular/material/core';
import { APPHOST } from '../../../app.component';

@Component({
  selector: 'app-prod-card',
  standalone: true,
  imports: [CommonModule, RouterModule, MatIconModule, CartQtyControlComponent, MatRippleModule],
  templateUrl: './prod-card.component.html',
  styleUrl: './prod-card.component.scss'
})
export class ProdCardComponent implements OnInit {
  @Input()
  item: Item = { category: { slug: '' } };
  images = new Set<string>();
  stop: boolean = true;
  src?: string = '../assets/branding/fortnite2.mp4';
  @ViewChild("videoPlayer", { static: false }) videoplayer?: ElementRef;
  QUALITY = '0.6'
  @Input()
  isSS = false
  kokoicon = 1
  shortDes = ''
  @Input()
  isDark = false;

  constructor(public dialog: Dialog,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    private _changeDetectorRef: ChangeDetectorRef) {
  }
  ngOnInit(): void {
    // 3.5% markup added if price <= 10000 (moved from constructor to ngOnInit where item is populated)
    if (this.item && this.item.newPrice && this.item.newPrice <= 10000) {
      this.item.newPrice = this.item.newPrice /*+ (this.item.newPrice * 3.5 / 100) */;
    }

    // Strip HTML tags server-safe to prevent empty shortDes on the server (hydration mismatch)
    this.shortDes = (this.item.shortDescription ?? '').replace(/<[^>]*>/g, '');

    // Deterministic icon selection based on item ID to avoid hydration mismatch
    const idNum = this.item.id ? this.item.id.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0) : 0;
    this.kokoicon = (idNum % 5) + 1;

    if (isPlatformBrowser(this.platformId)) {
      this.src = "https://softnetcomputers.lk/assets/branding/fortnite3.webm";
    }
  }


  // @HostListener('mouseenter')
  // @HostListener('hover', ['$event'])
  playAudio(): void {
    // console.log('play vid bg');

    try {
      if (!this.stop) return
      // const audio = new Audio();
      // audio.src = '../../../../assets/branding/tap2.mp3';
      // // audio.volume=.10;
      // audio.load();
      // audio.play();
      this.src = "https://softnetcomputers.lk/assets/branding/fortnite3.webm#t=" + Math.floor(Math.random() * 40)
      this.stop = false;
      this.videoplayer!.nativeElement.play();

      (document.getElementById("myVideo") as HTMLVideoElement).play();

    } catch (error) {

    }

  }

  stopAnim() {
    // setTimeout(() => {
    this.stop = true;

  }
  // @HostListener("click", ["$event"])
  // @HostListener('window:beforeunload', ['$event'])
  handleLike($event: any, id: string) {
    $event.preventDefault()
    $event.stopPropagation();
    // $event.returnValue = true;
    // this.downloadCanvasAsImage(id);
    this.open();
  }
  open() {
    this.createImageSet();
    this.dialog.open(CartQtyControlComponent, {
      width: '100vw',
      minHeight: '100%',
      height: '100vh',
      // minHeight: '100%',
      data: {
        product: this.item,
        images: this.images
      },
      hasBackdrop: true,
      disableClose: false

    });
  }

  createImageSet() {
    if (this.item!.image1)
      this.images.add(APPHOST + this.item!.image1!.replace('/image', '/image/thumb/300/' + this.QUALITY))
    if (this.item!.image2)
      this.images.add(APPHOST + this.item!.image2!.replace('/image', '/image/thumb/300/' + this.QUALITY))
    if (this.item!.image3)
      this.images.add(APPHOST + this.item!.image3!.replace('/image', '/image/thumb/300/' + this.QUALITY))
    if (this.item!.image4)
      this.images.add(APPHOST + this.item!.image4!.replace('/image', '/image/thumb/300/' + this.QUALITY))
    if (this.item!.image5)
      this.images.add(APPHOST + this.item!.image5!.replace('/image', '/image/thumb/300/' + this.QUALITY))
    if (this.item!.image6)
      this.images.add(APPHOST + this.item!.image6!.replace('/image', '/image/thumb/300/' + this.QUALITY))
  }

  urlAdjust(url: string): string {
    if (typeof url === undefined) {
      return ' ';
    }

    if (typeof url === null) {
      return ' ';
    }

    if (url === null) {
      return ' ';
    }


    return APPHOST + '/' + url.replace('image/thumb', 'image/thumb/220/' + this.QUALITY)
  }

  getPercentage() {
    if (this.item.newPrice && this.item.previousPrice && this.item.discounted) {
      return Math.round((this.item.previousPrice - this.item.newPrice) / this.item.previousPrice * 100).toFixed(0);
    }
    return 0;
  }

  callNumber(num: string, event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    if (isPlatformBrowser(this.platformId)) {
      window.location.href = `tel:${num}`;
    }
  }

}
